import { render, staticRenderFns } from "./ScanInfo.vue?vue&type=template&id=42c43a9f&scoped=true&"
import script from "./ScanInfo.vue?vue&type=script&lang=ts&"
export * from "./ScanInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ScanInfo.vue?vue&type=style&index=0&id=42c43a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c43a9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
